const config = {
  BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
  HOMEPAGE: process.env.NEXT_PUBLIC_SQUAD_HOMEPAGE,
  CHECKOUT: process.env.NEXT_PUBLIC_CHECKOUT_URL,
  TEST_ENCRYPT_KEY: process.env.NEXT_PUBLIC_TEST_ENCRYPT_KEY,
  LIVE_ENCRYPT_KEY: process.env.NEXT_PUBLIC_LIVE_ENCRYPT_KEY,
  ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
  TEST_PUSHER_API_KEY: process.env.NEXT_PUBLIC_TEST_PUSHER_API_KEY,
  PUSHER_API_KEY: process.env.NEXT_PUBLIC_PUSHER_API_KEY,
  TEST_PUSHER_CLUSTER: process.env.NEXT_PUBLIC_TEST_PUSHER_CLUSTER,
  PUSHER_CLUSTER: process.env.NEXT_PUBLIC_PUSHER_CLUSTER,
  X_ENV_AUTH: process.env.NEXT_PUBLIC_X_ENV_AUTH,
};

export default config;
